module.exports = __webpack_public_path__ + "img/bigcommerce.517c2207.png";